import { Button } from "@/components/ui/button";

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      {/* Header Section */}
      <div className="bg-white py-16 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-5xl font-bold text-gray-900 mb-6">
            Music Publishing 101
          </h1>
          <p className="text-xl text-gray-600 mb-8">
            Everything You Need to Know About Music Publishing
          </p>
          <p className="text-lg text-gray-700 max-w-2xl mx-auto">
            Learn the fundamentals of music publishing, royalties, licensing, and how to protect and monetize your musical creations.
          </p>
        </div>
      </div>

      {/* Orange CTA Section */}
      <div className="bg-orange-500 py-20 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            Download It Free Now
          </h2>
          <p className="text-xl text-orange-100 mb-8 max-w-2xl mx-auto">
            Get instant access to our comprehensive guide that will help you understand the music publishing industry and start earning from your music.
          </p>
          <Button 
            asChild
            size="lg"
            className="bg-white text-orange-500 hover:bg-orange-50 text-xl px-8 py-4 h-auto font-bold"
          >
            <a 
              href="https://forms.gle/8rvgJTZ8byZUDe1p7" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              GET FREE E-BOOK NOW!
            </a>
          </Button>
        </div>
      </div>

      {/* Features Section */}
      <div className="bg-gray-50 py-16 px-4">
        <div className="max-w-4xl mx-auto">
          <h3 className="text-3xl font-bold text-center text-gray-900 mb-12">
            What You'll Learn
          </h3>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="bg-orange-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl">📚</span>
              </div>
              <h4 className="text-xl font-semibold mb-2">Publishing Basics</h4>
              <p className="text-gray-600">Understand the fundamentals of music publishing and how it works.</p>
            </div>
            <div className="text-center">
              <div className="bg-orange-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl">💰</span>
              </div>
              <h4 className="text-xl font-semibold mb-2">Royalty Types</h4>
              <p className="text-gray-600">Learn about different types of royalties and how to collect them.</p>
            </div>
            <div className="text-center">
              <div className="bg-orange-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl">⚖️</span>
              </div>
              <h4 className="text-xl font-semibold mb-2">Legal Protection</h4>
              <p className="text-gray-600">Protect your music and understand licensing agreements.</p>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="bg-gray-900 text-white py-8 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <p className="text-gray-400">
            © 2024 Music Publishing 101. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Index;
